import {
  Button,
  Dialog,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { Icon } from "@iconify/react";

import { useResponsive } from "@app/hooks";
import { Strings } from "@app/constants";

const DialogBox = ({ open, onClose, onClick }: any) => {
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();

  const PhoneNumber = "99000 14565";
  const fullPhoneNumber = "+919900014565";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: isMobile ? "100%" : "55%",
          maxWidth: isMobile ? "100%" : "90%",
          borderRadius: isMobile ? 0 : 3,
          p: isMobile ? 2 : 0,
        },
      }}
    >
      <Stack
        sx={{
          maxHeight: "100vh",
          overflowY: "auto",
          "&::-webkit-scrollbar": { display: "none" },
          backgroundColor: theme.palette.common.white,
          p: { xs: 2, md: 5 },
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
        }}
      >
        <Stack
          sx={{
            position: "absolute",
            right: 5,
            top: 5,
          }}
        >
          <IconButton onClick={onClose}>
            <Icon icon={"material-symbols:close"} />
          </IconButton>
        </Stack>
        <Stack
          sx={{
            backgroundColor: theme.palette.primary.main,
            borderRadius: "50%",
            p: 2,
          }}
        >
          <Icon
            icon={"tabler:car-filled"}
            fontSize={32}
            color={theme.palette.common.white}
          />
        </Stack>
        <Stack
          sx={{
            mt: 2,
            width: { xs: "100%", md: "60%" },
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.light,
              textAlign: "center",
              fontSize: { xs: 18, md: 30 },
            }}
          >
            {Strings.landingPage.getReadyForOur}
          </Typography>
        </Stack>
        <Stack
          sx={{
            backgroundColor: theme.palette.grey[200],
            width: "100%",
            alignItems: "center",
            py: 2,
            borderRadius: 1,
            mt: { xs: 2, md: 5 },
            gap: 1,
          }}
        >
          <Typography sx={{ fontSize: 18, fontWeight: 500 }}>
            {Strings.landingPage.getInTouchWith}
          </Typography>
          <Stack
            flexDirection={"row"}
            sx={{
              alignItems: "center",
              gap: 1,
            }}
          >
            <Icon icon={"ic:baseline-phone"} fontSize={18} />
            <Typography variant="h5">{PhoneNumber}</Typography>
          </Stack>
        </Stack>

        <Stack
          sx={{
            flexDirection: "row",
            gap: 3,
            mt: 3,
          }}
        >
          <Button variant="outlined" size="medium" onClick={onClick}>
            {Strings.button.maybeLater}
          </Button>
          <Button
            variant="contained"
            size="medium"
            href={`tel:${fullPhoneNumber}`}
          >
            {Strings.button.callNow}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export { DialogBox };
